// home page bundle -> dist/js/pages/home.min.js
//
// Plain-ES port of the v3 home interactions (originally a React/DCLogic
// component: people-equation/dc/home.logic.js on feat/v3-design-pages). No
// framework: nodes are re-selected via data-* hooks and section ids. The dead
// v3 code (box(), specs(), the _flyLocked branch) is intentionally not ported.
//
// Behaviours: hero parallax/fade, the "+" fly-to-marker morph, the story
// scrollytelling engine (lerp 0.17, HOLD plateau, solo <640px, fin finale),
// model lobe reveal + click-to-open, offering accordion + offer hover rule,
// value reveal + ambient loops, outcome picker, the client marquee
// pause-on-hover + logo testimonial tooltip (180ms grace, positionTip), summary
// reveal + hover replay, begin/news reveals, newsletter field focus, and the
// ambient grid drift. The shared nav interactions (scroll auto-hide, dropdown
// panels, mobile menu) AND the newsletter form's submit now live in chrome.js,
// loaded on every page. Width-driven layout lives in home.scss media queries
// (v3 did it in applyMotion).

(function () {
  "use strict";

  var root = document.querySelector(".pe-home");
  if (!root) return;

  var q = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  // --- nodes --------------------------------------------------------------
  var hero = document.getElementById("pe-hero");
  var plus = q("[data-hero-plus]");
  var bird = q("[data-bird]");
  var grid = q("[data-grid]");
  var content = q("[data-hero-content]");
  var fly = q("[data-fly]");
  var storyWrap = q("[data-story-wrap]");
  var storyStage = q("[data-story-stage]");
  var track = q("[data-story-track]");
  var progress = q("[data-story-progress]");
  var marker = q("[data-story-marker]");
  var model = document.getElementById("pe-model");
  var cards = q("[data-cards]");
  var value = document.getElementById("pe-value");
  var summary = document.getElementById("pe-summary");
  var begin = document.getElementById("pe-begin");
  var news = document.getElementById("pe-news");
  var ribbon = q("[data-ribbon]");
  var outcome = q("[data-outcome]");

  var vw = window.innerWidth;

  // Section heights are read every frame by the scroll engine; caching them
  // (recomputed on resize) keeps the rAF loop from forcing a layout each frame.
  var heroH = 0, storyH = 0;
  function measure() {
    if (hero) heroH = hero.offsetHeight;
    if (storyWrap) storyH = storyWrap.offsetHeight;
  }

  // ============================ hero + fly morph ==========================
  function updateFly(y) {
    if (!hero) return;
    // Hero copy still eases up/fades a touch as you scroll past it.
    if (content) {
      var h = heroH || 1;
      var cq = Math.min(1, y / h);
      content.style.transform = "translateY(" + (cq * h * 0.16).toFixed(1) + "px)";
      content.style.opacity = (1 - cq * 0.72).toFixed(3);
    }
    // The "+" no longer flies down into the story marker (removed per request):
    // keep it in the headline, keep the floating clone hidden, and leave the
    // story marker statically visible where the "+" used to land.
    if (plus) plus.style.opacity = "1";
    if (fly) fly.style.opacity = "0";
    if (marker) marker.style.opacity = "1";
  }

  // ======================== story scrollytelling ==========================
  var storyP = null, evolving = false, fin = 0, finAt = 0, finOn = null;
  var storyActive = -1, markLeft = null;
  var sFlow, sSlots, sArrows, sVizs, sCaps, sDetails, sTexts, sNavItems, sEdges, sTextWrap;

  function fadeStory(nodes, s0, e) {
    for (var k = 0; k < nodes.length; k++) {
      var o = 0, dy = 0;
      if (k === s0) { o = Math.max(0, 1 - e / 0.5); dy = -e * 26; }
      else if (k === s0 + 1) { var g = Math.max(0, (e - 0.5) / 0.5); o = g; dy = (1 - g) * 22; }
      nodes[k].style.opacity = o.toFixed(3);
      nodes[k].style.transform = "translateY(" + dy.toFixed(1) + "px)";
      nodes[k].style.pointerEvents = o > 0.5 ? "auto" : "none";
    }
  }

  function updateStory(y) {
    if (!storyWrap || !storyStage) return;
    var rect = storyWrap.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    if (rect.top > vh * 1.2 || rect.bottom < -vh * 0.2) { evolving = false; return; }

    var total = Math.max(1, storyH - vh);
    var target = Math.min(1, Math.max(0, -rect.top / total));
    var prev = storyP == null ? target : storyP;
    var settled = Math.abs(target - prev) < 0.0004;
    var p = settled ? target : prev + (target - prev) * 0.17;
    storyP = p;
    var rawSeg = p * 3;
    var s0 = Math.min(2, Math.floor(rawSeg));
    var f = rawSeg - s0;
    var HOLD = 0.34;
    var lin = f <= HOLD ? 0 : Math.min(1, (f - HOLD) / (1 - HOLD));
    var e = lin * lin * (3 - 2 * lin);
    var seg = s0 + e;
    evolving = !settled || seg > 2.05 || fin > 0.002 || !!finAt;

    if (!sFlow) {
      sFlow = storyStage.querySelector("[data-flow]");
      sSlots = storyStage.querySelectorAll("[data-slot]");
      sArrows = storyStage.querySelectorAll("[data-arrow]");
      sVizs = storyStage.querySelectorAll("[data-viz]");
      sCaps = storyStage.querySelectorAll("[data-cap]");
    }
    var WT = [[1, 0, 0, 0], [0.30, 1, 0, 0], [0.22, 0.34, 1, 0], [0.17, 0.25, 0.36, 1]];
    var wa = WT[s0], wb = WT[s0 + 1] || WT[3];
    var flowW = sFlow.clientWidth, flowH = sFlow.clientHeight;
    // Read the track width up here, before the style writes below, so it can't
    // trigger a forced reflow mid-frame (it was read after the writes before).
    var trackW = track ? track.clientWidth : 0;
    var aw = Math.max(22, Math.min(62, flowW * 0.05));
    var wts = [0, 0, 0, 0], rev = [1, 0, 0, 0];
    var sum = 0, arrowTotal = 0, i;
    for (i = 0; i < 4; i++) {
      wts[i] = wa[i] + (wb[i] - wa[i]) * e;
      sum += wts[i];
      if (i > 0) { rev[i] = Math.min(1, Math.max(0, (seg - i + 0.92) / 0.6)); arrowTotal += rev[i] * aw; }
    }
    var solo = flowW < 640;
    if (solo) {
      var act = Math.round(seg);
      for (i = 0; i < 4; i++) { wts[i] = i === act ? 1 : 0; rev[i] = i === act ? 1 : 0; }
      sum = 1; arrowTotal = 0;
    }
    var nowMs = performance.now();
    if (!solo && seg > 2.985) { if (!finAt) finAt = nowMs; } else finAt = 0;
    var finTarget = (finAt && nowMs - finAt > 3000) ? 1 : 0;
    fin = fin + (finTarget - fin) * 0.055;
    if (fin < 0.002) fin = 0;
    if (fin > 0) {
      var FW = [1.18, 0.94, 0.94, 0.94];
      sum = 0; arrowTotal = 0;
      for (i = 0; i < 4; i++) {
        wts[i] = wts[i] + (FW[i] - wts[i]) * fin;
        rev[i] = Math.max(rev[i], fin);
        sum += wts[i];
        if (i > 0) arrowTotal += rev[i] * aw;
      }
    }
    if (!sDetails) sDetails = storyStage.querySelectorAll("[data-detail]");
    for (var k = 0; k < sDetails.length; k++) sDetails[k].style.opacity = (1 - fin).toFixed(3);
    var fOn = fin > 0.5;
    if (fOn !== finOn) { finOn = fOn; storyActive = -1; }
    var space = Math.max(80, flowW - arrowTotal);
    var vizH = Math.max(40, flowH - 34);
    for (i = 0; i < 4; i++) {
      var pw = sum > 0 ? (wts[i] / sum) * space : 0;
      var near = Math.min(1, Math.max(0, 1 - Math.abs(seg - i)));
      sSlots[i].style.width = pw.toFixed(1) + "px";
      var op = rev[i] * (0.52 + 0.48 * near);
      sSlots[i].style.opacity = (op + (1 - op) * fin).toFixed(3);
      var bw = i === 0 ? 1000 : 620, bh = i === 0 ? 240 : 340;
      // viz 0 (the wide "four conditions" sliders) carries a 0.74 breathing
      // margin at desktop so it doesn't crowd the column. On phones (solo) the
      // stage is width-starved and that margin just wastes the little width we
      // have, so let it fill the full column there.
      var fit = i === 0 ? (solo ? 1 : 0.74) : 1;
      var s = Math.max(0.04, Math.min(pw / bw, vizH / bh) * fit);
      sVizs[i].style.transform = "translate(-50%,-50%) scale(" + s.toFixed(4) + ")";
      if (i > 0) {
        var arv = solo ? 0 : rev[i];
        sArrows[i - 1].style.width = (arv * aw).toFixed(1) + "px";
        sArrows[i - 1].style.opacity = (arv * 0.85).toFixed(3);
      }
    }
    if (!sTexts) {
      sTexts = storyWrap.querySelectorAll("[data-text]");
      sNavItems = storyWrap.querySelectorAll("[data-stage]");
      sEdges = storyWrap.querySelectorAll("[data-edge]");
      sTextWrap = sTexts.length ? sTexts[0].parentElement : null;
    }
    fadeStory(sTexts, s0, e);

    var active = Math.min(3, Math.round(seg));
    if (active !== storyActive) {
      storyActive = active;
      // Mobile: the four beats are overlaid in one grid cell, so the cell
      // always reserves the tallest beat's height — which stranded the diagram
      // far below the short beats (e.g. "four conditions") with a big dead gap.
      // On phones, let the cell size to the ACTIVE beat by taking the others out
      // of flow, so the diagram rides up right under each beat's text. The one
      // step happens at the beat crossfade midpoint, where the text is already
      // fading and the diagram is morphing, so it reads as part of the same move.
      if (sTextWrap) {
        if (solo) {
          sTextWrap.style.position = "relative";
          for (var kt = 0; kt < sTexts.length; kt++) {
            var on = kt === active;
            sTexts[kt].style.position = on ? "relative" : "absolute";
            sTexts[kt].style.top = on ? "" : "0";
            sTexts[kt].style.left = on ? "" : "0";
            sTexts[kt].style.right = on ? "" : "0";
          }
        } else {
          sTextWrap.style.position = "";
          for (var kr = 0; kr < sTexts.length; kr++) {
            sTexts[kr].style.position = "";
            sTexts[kr].style.top = "";
            sTexts[kr].style.left = "";
            sTexts[kr].style.right = "";
          }
        }
      }
      for (var k2 = 0; k2 < sNavItems.length; k2++) {
        var on = k2 === active;
        var lab = sNavItems[k2].querySelector("[data-nav-label]");
        var tick = sNavItems[k2].querySelector("[data-tick]");
        if (lab) lab.style.color = on ? "#FFFFFF" : "rgba(255,255,255,.38)";
        if (tick) { tick.style.background = on ? "#F2673A" : "rgba(255,255,255,.30)"; tick.style.height = on ? "13px" : "9px"; tick.style.opacity = on ? "0" : "1"; }
      }
      for (var k3 = 0; k3 < sCaps.length; k3++) {
        sCaps[k3].style.color = k3 === active ? "#F2673A" : (finOn ? "rgba(255,255,255,.6)" : "rgba(255,255,255,.4)");
      }
      for (var k4 = 0; k4 < sEdges.length; k4++) {
        var eon = sEdges[k4].dataset.edge === "before" ? active < 2 : active >= 2;
        sEdges[k4].style.color = eon ? "rgba(255,255,255,.72)" : "rgba(255,255,255,.30)";
      }
    }
    if (track) {
      var left = trackW * (0.2 + 0.2 * active);
      if (Math.abs(left - (markLeft == null ? -1 : markLeft)) > 0.4) {
        markLeft = left;
        if (marker) marker.style.left = left.toFixed(1) + "px";
        if (progress) progress.style.width = left.toFixed(1) + "px";
      }
    }
  }

  // ============================ model reveal ==============================
  var modelShown = false, modelObs = null;
  function watchModel() {
    if (modelShown || !model) return;
    if (!modelObs && typeof IntersectionObserver !== "undefined") {
      modelObs = new IntersectionObserver(function (en) {
        for (var i = 0; i < en.length; i++) if (en[i].isIntersecting) revealModel();
      }, { rootMargin: "-12% 0px -12% 0px" });
      modelObs.observe(model);
    }
    var r = model.getBoundingClientRect();
    if (r.top > window.innerHeight * 0.88 || r.bottom < 0) return;
    revealModel();
  }
  function revealModel() {
    if (modelShown || !model) return;
    modelShown = true;
    if (modelObs) modelObs.disconnect();
    var els = model.querySelectorAll("[data-mc]");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.style.opacity = "1";
      if (el.dataset.sep) el.style.transform = el.dataset.sep;
      else el.style.transform = el.style.transform.indexOf("translateX") > -1 ? "translateX(-50%)" : "none";
    }
    var lobes = model.querySelectorAll("[data-sep]");
    for (var j = 0; j < lobes.length; j++) {
      lobes[j].style.animation = lobes[j].dataset.anim + " 11s cubic-bezier(.35,.7,.25,1) 2.1s infinite";
    }
  }

  // ============================ value reveal ==============================
  // QA round 1: the value ("how we drive value") reveal used to fire once and
  // never again. It now replays on every entry via an IntersectionObserver —
  // each element's original inline style is captured up front, restored on exit
  // (which also clears the perpetual ambient loops), and re-applied on the next
  // entry so the whole draw-in runs again. Same reset+reflow+rAF replay trick
  // the summary cards use for their hover replay.
  var valueTimer = 0;
  function valueEls() { return value ? value.querySelectorAll("[data-vc],[data-bar],[data-blk],[data-line],[data-dot],[data-area],[data-vsvg]") : []; }
  function captureValueInit() {
    var els = valueEls();
    for (var i = 0; i < els.length; i++) { if (els[i]._vinit == null) els[i]._vinit = els[i].getAttribute("style") || ""; }
  }
  function resetValue() {
    if (valueTimer) { clearTimeout(valueTimer); valueTimer = 0; }
    var els = valueEls();
    for (var i = 0; i < els.length; i++) { if (els[i]._vinit != null) els[i].setAttribute("style", els[i]._vinit); }
  }
  function playValue() {
    if (!value) return;
    var vc = value.querySelectorAll("[data-vc]");
    for (var a = 0; a < vc.length; a++) { vc[a].style.opacity = "1"; vc[a].style.transform = "none"; }
    var bars = value.querySelectorAll("[data-bar]");
    for (var b = 0; b < bars.length; b++) bars[b].style.width = "32%";
    var blks = value.querySelectorAll("[data-blk]");
    for (var c = 0; c < blks.length; c++) { blks[c].style.opacity = "1"; blks[c].style.transform = "scale(1)"; }
    var lines = value.querySelectorAll("[data-line]");
    for (var d = 0; d < lines.length; d++) lines[d].style.strokeDashoffset = "0";
    var soft = value.querySelectorAll("[data-dot],[data-area]");
    for (var s = 0; s < soft.length; s++) soft[s].style.opacity = "1";

    valueTimer = setTimeout(function () {
      valueTimer = 0;
      for (var i = 0; i < blks.length; i++) blks[i].style.animation = "peBlockPulse " + (8.5 + i * 0.4).toFixed(1) + "s ease-in-out " + (i * 0.42).toFixed(2) + "s infinite";
      for (var j = 0; j < bars.length; j++) { bars[j].style.transformOrigin = "left center"; bars[j].style.animation = "peBarBreathe " + (11 + j * 1.6).toFixed(1) + "s ease-in-out " + (j * 0.9).toFixed(1) + "s infinite"; }
      var svgs = value.querySelectorAll("[data-vsvg]");
      for (var k = 0; k < svgs.length; k++) svgs[k].style.animation = "peSway " + (12 + k * 2.5).toFixed(1) + "s ease-in-out " + (k * 1.4).toFixed(1) + "s infinite";
      var dots = value.querySelectorAll("[data-dot]");
      for (var m = 0; m < dots.length; m++) { dots[m].style.transformBox = "fill-box"; dots[m].style.transformOrigin = "center"; dots[m].style.animation = "peDot " + (7.5 + m).toFixed(1) + "s ease-in-out " + (m * 0.7).toFixed(1) + "s infinite"; }
    }, 2400);
  }
  function replayValue() {
    resetValue();
    void value.offsetWidth; // force a reflow so the transitions restart from the reset state
    requestAnimationFrame(playValue);
  }
  var valueObs = null;
  function watchValue() {
    // Fallback path only (no IntersectionObserver): a one-time reveal, as before.
    if (!value || valueObs) return;
    var r = value.getBoundingClientRect();
    if (r.top > window.innerHeight * 0.82 || r.bottom < 0) return;
    playValue();
    window.removeEventListener("scroll", watchValue);
  }
  if (value && typeof IntersectionObserver !== "undefined") {
    captureValueInit();
    valueObs = new IntersectionObserver(function (en) {
      for (var i = 0; i < en.length; i++) {
        if (en[i].isIntersecting) replayValue();
        else resetValue();
      }
    }, { rootMargin: "-18% 0px -18% 0px" });
    valueObs.observe(value);
  }

  // =========================== summary reveal =============================
  var sumShown = false;
  function playSummary(scope) {
    var els = scope.querySelectorAll("[data-sfill],[data-sbar],[data-sfade],[data-sep]");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el._sinit == null) el._sinit = el.getAttribute("style") || "";
      var d = el.dataset;
      if (d.sfill != null) el.style.width = d.sfill + "%";
      if (d.sbar != null) el.style.width = d.sbar + "%";
      if (d.sfade != null) { el.style.opacity = "1"; el.style.transform = "none"; }
      if (d.sep != null) el.style.transform = "none";
    }
  }
  function replaySummary(scope) {
    var els = scope.querySelectorAll("[data-sfill],[data-sbar],[data-sfade],[data-sep]");
    for (var i = 0; i < els.length; i++) { if (els[i]._sinit != null) els[i].setAttribute("style", els[i]._sinit); }
    void scope.offsetWidth;
    requestAnimationFrame(function () { playSummary(scope); });
  }
  function watchSummary() {
    if (sumShown || !summary) return;
    var r = summary.getBoundingClientRect();
    if (r.top > window.innerHeight * 0.82 || r.bottom < 0) return;
    sumShown = true;
    var blocks = summary.querySelectorAll("[data-sc]");
    for (var i = 0; i < blocks.length; i++) { blocks[i].style.opacity = "1"; blocks[i].style.transform = "none"; }
    playSummary(summary);
  }
  function colEnter(e) {
    var w = e.currentTarget;
    w.style.transition = "transform .45s cubic-bezier(.2,.7,.3,1),box-shadow .45s ease,background .45s ease";
    w.style.transform = "translateY(-6px)";
    w.style.background = "rgba(255,255,255,.62)";
    w.style.boxShadow = "0 18px 42px rgba(18,63,68,.10)";
    var vis = w.querySelector("[data-svis]");
    if (vis && sumShown) replaySummary(vis);
  }
  function colLeave(e) {
    var w = e.currentTarget;
    w.style.transform = "none"; w.style.background = "transparent"; w.style.boxShadow = "none";
  }

  // ========================= begin / news reveal ==========================
  var beginShown = false, newsShown = false;
  function watchBegin() {
    if (beginShown || !begin) return;
    var r = begin.getBoundingClientRect();
    if (r.top > window.innerHeight * 0.85 || r.bottom < 0) return;
    beginShown = true;
    var els = begin.querySelectorAll("[data-bc]");
    for (var i = 0; i < els.length; i++) { els[i].style.opacity = "1"; els[i].style.transform = "none"; }
  }
  function watchNews() {
    if (newsShown || !news) return;
    var r = news.getBoundingClientRect();
    if (r.top > window.innerHeight * 0.86 || r.bottom < 0) return;
    newsShown = true;
    var els = news.querySelectorAll("[data-nc]");
    for (var i = 0; i < els.length; i++) { els[i].style.opacity = "1"; els[i].style.transform = "none"; }
  }

  // ========================== offering accordion ==========================
  var openCardIdx = null;
  function syncCards() {
    if (!cards) return;
    var cardEls = cards.querySelectorAll("[data-card]");
    var narrow = window.innerWidth < 900;
    var open = openCardIdx;
    cards.style.flexDirection = narrow ? "column" : "row";
    for (var i = 0; i < cardEls.length; i++) {
      var card = cardEls[i];
      var closed = card.querySelector("[data-closed]");
      var spine = card.querySelector("[data-spine]");
      var panel = card.querySelector("[data-panel]");
      var isOpen = open === i;
      var isCollapsed = open !== null && !isOpen && !narrow;
      card.style.flex = isOpen ? "1 1 100%" : (isCollapsed ? "0 0 58px" : "1 1 0");
      if (closed) closed.style.display = isOpen ? "none" : (isCollapsed ? "none" : "flex");
      if (spine) spine.style.display = isCollapsed ? "flex" : "none";
      if (panel) { panel.style.display = isOpen ? "block" : "none"; panel.style.opacity = isOpen ? "1" : "0"; }
    }
  }
  function openCard(e) { var i = parseInt(e.currentTarget.dataset.i, 10); openCardIdx = openCardIdx === i ? null : i; syncCards(); }
  function closeCard(e) { if (e) e.stopPropagation(); openCardIdx = null; syncCards(); }

  // ============================ smooth jumps ==============================
  function goSection(e) {
    var host = e.currentTarget;
    var href = host.getAttribute("href") || "";
    if (href.charAt(0) !== "#") return;
    var el = document.getElementById(href.slice(1));
    e.preventDefault();
    if (!el) return;
    var oc = host.dataset.open;
    if (oc != null && oc !== "") { openCardIdx = parseInt(oc, 10); syncCards(); }
    var top = el.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }
  function goStage(e) {
    e.preventDefault();
    if (!storyWrap) return;
    var k = parseInt(e.currentTarget.dataset.stage, 10) || 0;
    var top = storyWrap.getBoundingClientRect().top + window.scrollY;
    var total = Math.max(1, storyWrap.offsetHeight - window.innerHeight);
    window.scrollTo({ top: top + total * (k / 3), behavior: "smooth" });
  }

  // ============================ outcome picker ============================
  var outcomeKey = null;
  function pickOutcome(e) { var key = e.currentTarget.dataset.out; outcomeKey = outcomeKey === key ? null : key; syncOutcome(); }
  function syncOutcome() {
    if (!outcome) return;
    var chips = outcome.querySelectorAll("[data-out]");
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var on = chip.dataset.out === outcomeKey;
      var dot = chip.querySelector("[data-out-dot]");
      if (dot) { dot.style.background = on ? "#F2673A" : "rgba(255,255,255,.3)"; dot.style.transform = on ? "scale(1.4)" : "scale(1)"; }
      chip.style.borderColor = on ? "#F2673A" : "rgba(255,255,255,.2)";
      chip.style.background = on ? "rgba(242,103,58,.14)" : "transparent";
      chip.setAttribute("aria-pressed", on ? "true" : "false");
    }
    var host = outcome.parentNode;
    var lines = host ? host.querySelectorAll("[data-out-line]") : [];
    for (var j = 0; j < lines.length; j++) {
      var lon = lines[j].dataset.outLine === outcomeKey;
      lines[j].style.opacity = lon ? "1" : "0";
      lines[j].style.transform = lon ? "none" : "translateY(4px)";
    }
    // Carry the picked outcome to the contact page so its form arrives with
    // that chip already selected (contact-us.js reads ?outcome=).
    var cta = host ? host.querySelector("a.scpg") : null;
    if (cta) {
      if (!cta.dataset.base) cta.dataset.base = (cta.getAttribute("href") || "").split("?")[0];
      cta.setAttribute("href", outcomeKey ? cta.dataset.base + "?outcome=" + encodeURIComponent(outcomeKey) : cta.dataset.base);
    }
  }

  // ===================== marquee + testimonial tooltip ====================
  var tips = {};
  try { var raw = document.getElementById("pe-home-tips"); if (raw) tips = JSON.parse(raw.textContent || "{}"); } catch (err) { tips = {}; }
  var tipEl = null, tipRect = null, tipTimer = 0, tipIndex = null;

  // The marquee logos were authored for the old dark band, so most are white/
  // light marks — invisible on the band's new white background. But a few ship
  // as self-contained chips (a dark box with white text inside) that read fine
  // on white and turn into solid blobs if blanket-darkened. CSS can't tell the
  // two apart, so classify each unique logo at load: draw it on a canvas and
  // check the mean luminance of its opaque pixels — predominantly light means
  // "white mark, darken it" (the pe-logo-ink class in home.scss); anything else
  // is left as authored.
  //
  // The logos are served cross-origin from the GCS media bucket (WP Stateless),
  // and the display <img> carries no crossorigin attribute — so drawing it on a
  // canvas taints the canvas and getImageData() throws. That left EVERY logo
  // unclassified, and the light ones invisible on the white band. So we don't
  // read the display <img>: we load a second, CORS-enabled copy of the same URL
  // and read that. The bucket sends Access-Control-Allow-Origin only on a fresh
  // request — the plain URL is already cached (from the display <img>) without
  // the CORS header — so the probe appends a query string to force a clean CORS
  // fetch. If the probe still fails (CORS off, decode error), the logo is left
  // as authored, exactly as before.
  var inkCache = {};
  function applyClass(src, cls) {
    $$("#pe-clients [data-track] img").forEach(function (m) {
      if ((m.currentSrc || m.src) === src) {
        m.classList.toggle("pe-logo-ink", "ink" === cls);
        m.classList.toggle("pe-logo-chip", "chip" === cls);
      }
    });
  }
  function classifySrc(src) {
    if (!src) return;
    if (src in inkCache) { applyClass(src, inkCache[src]); return; }
    inkCache[src] = "";
    var probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.decoding = "async";
    var done = function () { applyClass(src, inkCache[src]); };
    probe.onload = function () {
      try {
        var w = Math.min(probe.naturalWidth || 0, 96), h = Math.min(probe.naturalHeight || 0, 96);
        if (w && h) {
          var cv = document.createElement("canvas");
          cv.width = w; cv.height = h;
          var c2 = cv.getContext("2d");
          c2.drawImage(probe, 0, 0, w, h);
          var d = c2.getImageData(0, 0, w, h).data;
          var n = 0, dark = 0, lum;
          for (var p = 0; p < d.length; p += 4) {
            if (d[p + 3] > 40) {
              lum = 0.299 * d[p] + 0.587 * d[p + 1] + 0.114 * d[p + 2];
              n++;
              if (lum < 110) dark++;
            }
          }
          if (n > 0) {
            var darkFrac = dark / n, coverage = n / (w * h);
            // Enough genuinely dark pixels -> the mark is legible on white as
            // authored (dark wordmarks, colour marks like BMW, and white plates
            // with dark text — the plate just melts into the white band).
            if (darkFrac < 0.1) {
              // No dark ink anywhere. Dense marks (plates, filled crests — solid
              // shapes) can't be blackened without blobbing, so they get the
              // stronger "chip" dim; sparse light wordmarks are blackened to an
              // ink silhouette.
              inkCache[src] = coverage >= 0.55 ? "chip" : "ink";
            }
          }
        }
      } catch (err) { /* tainted/failed decode: leave the logo as authored */ }
      done();
    };
    probe.onerror = done; // CORS or network failed: leave the logo as authored.
    probe.src = src + (src.indexOf("?") >= 0 ? "&" : "?") + "pev2cors=1";
  }
  $$("#pe-clients [data-track] img").forEach(function (img) {
    classifySrc(img.currentSrc || img.src);
  });

  function setRibbon(state) {
    if (!ribbon) return;
    var tracks = ribbon.querySelectorAll("[data-track]");
    for (var i = 0; i < tracks.length; i++) tracks[i].style.animationPlayState = state;
  }
  function ribbonPause() { setRibbon("paused"); }
  function ribbonPlay() { if (tipIndex == null) setRibbon("running"); }
  function tipHold() { if (tipTimer) { clearTimeout(tipTimer); tipTimer = 0; } }

  function ensureTip() {
    if (tipEl) return tipEl;
    tipEl = document.createElement("div");
    tipEl.setAttribute("style", "position:fixed;left:0;top:0;z-index:150;width:min(430px,88vw);max-height:70vh;overflow-y:auto;padding:16px 19px 16px;background:rgba(8,35,38,.98);border:1px solid rgba(255,255,255,.16);box-shadow:0 20px 50px rgba(4,20,22,.5);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);opacity:0;transform:translateY(6px);transition:opacity .25s ease,transform .25s ease");
    tipEl.addEventListener("mouseover", tipHold);
    tipEl.addEventListener("mouseout", logoLeave);
    document.body.appendChild(tipEl);
    return tipEl;
  }
  function buildTip(data) {
    var t = ensureTip();
    t.innerHTML = "";
    var kick = document.createElement("div");
    kick.setAttribute("style", "font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:#F2673A");
    kick.textContent = data.kicker || "";
    t.appendChild(kick);
    var list = document.createElement("div");
    list.setAttribute("style", "display:flex;flex-direction:column;gap:15px;margin-top:12px");
    (data.quotes || []).forEach(function (qt) {
      var rowEl = document.createElement("div");
      rowEl.setAttribute("style", "display:flex;gap:14px;align-items:flex-start;padding-top:14px;border-top:1px solid rgba(255,255,255,.12)");
      var img = document.createElement("img");
      img.src = qt.img || ""; img.alt = ""; img.loading = "lazy";
      img.setAttribute("style", "flex:0 0 auto;width:58px;height:58px;border-radius:6px;object-fit:cover;object-position:50% 25%;background:rgba(255,255,255,.08)");
      var col = document.createElement("div");
      col.setAttribute("style", "display:flex;flex-direction:column;gap:9px;min-width:0");
      var p = document.createElement("p");
      p.setAttribute("style", "margin:0;font-size:13.5px;line-height:1.6;color:rgba(234,241,240,.88);white-space:pre-line");
      p.textContent = qt.q || "";
      var by = document.createElement("div");
      by.setAttribute("style", "font-size:12px;line-height:1.45;color:rgba(226,236,235,.55)");
      by.textContent = qt.a || "";
      col.appendChild(p); col.appendChild(by);
      rowEl.appendChild(img); rowEl.appendChild(col);
      list.appendChild(rowEl);
    });
    t.appendChild(list);
    var link = document.createElement("a");
    link.href = data.caseHref || "#"; link.target = "_blank"; link.rel = "noopener"; link.className = "scpk";
    link.setAttribute("style", "display:inline-flex;align-items:center;gap:9px;margin-top:16px;padding-top:14px;border-top:1px solid rgba(255,255,255,.12);font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.16em;text-transform:uppercase;text-decoration:none;color:#F2673A;transition:gap .25s ease,color .25s ease");
    link.innerHTML = "<span>Read the Case Study</span><span>&rarr;</span>";
    t.appendChild(link);
  }
  function positionTip() {
    var t = tipEl, r = tipRect;
    if (!t || !r) return;
    var w = t.offsetWidth, h = t.offsetHeight;
    var left = r.left + r.width / 2 - w / 2;
    left = Math.max(14, Math.min(left, window.innerWidth - w - 14));
    var top = r.top - h - 12;
    if (top < 14) top = r.bottom + 12;
    top = Math.max(14, Math.min(top, window.innerHeight - h - 14));
    t.style.left = left.toFixed(0) + "px";
    t.style.top = top.toFixed(0) + "px";
    requestAnimationFrame(function () {
      if (!tipEl) return;
      tipEl.style.opacity = "1";
      tipEl.style.transform = "translateY(0)";
    });
  }
  function logoEnter(e) {
    var i = parseInt(e.currentTarget.dataset.plus, 10);
    var data = tips[i];
    if (!data) return;
    tipHold();
    setRibbon("paused");
    tipRect = e.currentTarget.getBoundingClientRect();
    if (tipIndex !== i) { tipIndex = i; buildTip(data); }
    positionTip();
  }
  function logoLeave() {
    if (tipIndex == null) return;
    tipHold();
    tipTimer = setTimeout(function () {
      tipTimer = 0; tipIndex = null;
      if (tipEl) { tipEl.style.opacity = "0"; tipEl.style.transform = "translateY(6px)"; }
      setRibbon("running");
    }, 180);
  }
  function hideTipNow() {
    if (tipIndex == null) return;
    tipIndex = null;
    if (tipEl) { tipEl.style.opacity = "0"; tipEl.style.transform = "translateY(6px)"; }
    setRibbon("running");
  }

  // ============================ offer hover ==============================
  function offerEnter(e) {
    var host = e.currentTarget;
    var rule = host.querySelector("[data-rule]");
    var name = host.querySelector("[data-name]");
    var hue = host.dataset.hue;
    if (rule) rule.style.width = Math.max(56, host.offsetWidth) + "px";
    if (name) { name.style.transform = "translateX(6px)"; if (hue) name.style.color = hue; }
  }
  function offerLeave(e) {
    var host = e.currentTarget;
    var rule = host.querySelector("[data-rule]");
    var name = host.querySelector("[data-name]");
    if (rule) rule.style.width = "56px";
    if (name) { name.style.transform = "translateX(0)"; name.style.color = ""; }
  }

  // ============================ field focus ==============================
  function fieldFocus(e) { var el = e.currentTarget; el.style.borderBottomColor = "#2A868C"; el.style.transform = "translateY(-1px)"; }
  function fieldBlur(e) { var el = e.currentTarget; el.style.borderBottomColor = "rgba(20,24,26,.22)"; el.style.transform = "none"; }

  // ============================== wire up =================================
  $$("[data-hue]").forEach(function (o) { o.addEventListener("mouseenter", offerEnter); o.addEventListener("mouseleave", offerLeave); });
  $$("[data-open]").forEach(function (a) { a.addEventListener("click", goSection); });
  $$("[data-stage]").forEach(function (a) { a.addEventListener("click", goStage); });
  $$("[data-i]").forEach(function (b) { b.addEventListener("click", openCard); });
  if (cards) $$("[aria-label='Close']", cards).forEach(function (b) { b.addEventListener("click", closeCard); });
  $$("[data-out]").forEach(function (b) { b.addEventListener("click", pickOutcome); });
  $$("[data-sumcol]").forEach(function (c) { c.addEventListener("mouseenter", colEnter); c.addEventListener("mouseleave", colLeave); });
  $$("[data-plus]").forEach(function (s) { s.addEventListener("mouseover", logoEnter); s.addEventListener("mouseout", logoLeave); });
  if (ribbon) { ribbon.addEventListener("mouseover", ribbonPause); ribbon.addEventListener("mouseout", ribbonPlay); }
  // Newsletter form submit is wired sitewide by chrome.js; this only keeps
  // the input focus/blur micro-interaction.
  if (news) {
    $$("input", news).forEach(function (el) { el.addEventListener("focus", fieldFocus); el.addEventListener("blur", fieldBlur); });
  }

  // scroll: the section watchers (nav auto-hide lives in chrome.js)
  window.addEventListener("scroll", watchValue, { passive: true });
  window.addEventListener("scroll", watchModel, { passive: true });
  window.addEventListener("scroll", function () { watchSummary(); watchBegin(); watchNews(); hideTipNow(); }, { passive: true });
  window.addEventListener("resize", function () { vw = window.innerWidth; measure(); syncCards(); });

  // Drives fly + story + model. Runs a rAF loop only while the page is actually
  // scrolling or the story is still settling (`evolving`); when idle it stops
  // rescheduling, freeing the main thread. The old version re-armed rAF every
  // frame forever, so the loop (and its per-frame reads) never went quiet.
  var lastFrameY = -1, running = false;
  function frame() {
    var y = Math.max(0, window.scrollY || 0);
    var changed = y !== lastFrameY;
    if (changed || evolving) { lastFrameY = y; updateFly(y); updateStory(y); watchModel(); }
    if (changed || evolving) { requestAnimationFrame(frame); } else { running = false; }
  }
  function kick() { if (!running) { running = true; requestAnimationFrame(frame); } }
  window.addEventListener("scroll", kick, { passive: true });

  // initial paint + settle
  measure();
  kick();
  setTimeout(watchValue, 80);
  setTimeout(watchModel, 60);
  setTimeout(function () { watchSummary(); watchBegin(); watchNews(); }, 80);
  syncCards();

  // Ambient grid: kept static. It used to animate `background-position`, which
  // is not compositable — the browser repainted the hero-sized masked gradient
  // every frame on the main thread (a large, variable Total Blocking Time cost
  // that PageSpeed flagged). The grid texture itself is unchanged; only the slow
  // drift is dropped. (Reversible — a composited two-layer drift is possible if
  // the motion is wanted back.)
  if (grid) { grid.style.opacity = "0.85"; }
})();
